import React from "react";
import { connect } from "react-redux";
import { Map } from "immutable";
import {
    Progress,
    Button,
    ButtonActionGroup,
    Confirm,
    BTN_SMALL,
    TYPE_FAILURE,
    TYPE_SECONDARY,
} from "../../lib";
import { destroyDocUser } from "../../reducers/doc_users/actions";
import { navigate } from "../../services";
import { UD_EDITOR, UD_AUTHOR } from "../../settings";

type State = {
    processing: boolean;
    showEdit: boolean;
    showDelete: boolean;
    confirmDelete: boolean;
};

const mapDispatch = {
    destroyDocUser,
};
type DispatchProps = typeof mapDispatch;
type Props = DispatchProps & {
    doc_id: number;
    page_id: number;
    size: number;
    status: string;
    selected: string[];
    doc_users: Map<any, any>;
    selectedRow: Map<string, string>;

    clearSelected: () => void;
};

class Actions extends React.Component<Props, State> {
    state = {
        processing: false,
        showEdit: false,
        showDelete: false,
        confirmDelete: false,
    };

    componentWillReceiveProps(nextProps: Props) {
        const { status, size, selectedRow } = nextProps;

        if (selectedRow) {
            const editorCount = this.numOfEditors();
            const selectedStatus: string = selectedRow.get("status")!;

            if (size === 1) {
                this.setState({ showDelete: false });
            } else if (
                status === UD_EDITOR &&
                selectedStatus === UD_EDITOR &&
                editorCount > 1
            ) {
                this.setState({ showDelete: true });
            } else if (status === UD_EDITOR && selectedStatus !== UD_EDITOR) {
                this.setState({ showDelete: true });
            } else if (status === UD_AUTHOR && selectedStatus !== UD_EDITOR) {
                this.setState({ showDelete: true });
            } else {
                this.setState({ showDelete: false });
            }

            if (status === UD_EDITOR) {
                this.setState({ showEdit: true });
            } else if (status !== UD_EDITOR && selectedStatus === UD_EDITOR) {
                this.setState({ showEdit: false });
            } else if (status === UD_AUTHOR && selectedStatus !== UD_EDITOR) {
                this.setState({ showEdit: true });
            } else {
                this.setState({ showEdit: false });
            }
        } else {
            this.setState({ showEdit: false, showDelete: false });
        }
    }

    numOfEditors() {
        let count = 0;
        this.props.doc_users.forEach((u) => {
            if (u.get("status") === UD_EDITOR) {
                count += 1;
            }
        });
        return count;
    }

    onEditClick = () =>
        navigate.to(
            `/app/users/edit/${this.props.selected[0].split("-").join("/")}`
        );

    onDeleteClick = () => this.setState({ confirmDelete: true });

    onConfirmDelete = () => {
        const { selected } = this.props;

        try {
            const tmp = selected[0].split("-");
            this.props.destroyDocUser({ doc_id: tmp[0], user_id: tmp[1] });
        } catch (e) {
            console.warn(e);
        }

        this.setState({ confirmDelete: false });
        this.props.clearSelected();
    };

    onCancelDelete = () => {
        this.setState({ confirmDelete: false });
        this.props.clearSelected();
    };

    onReturnClick = () => {
        const { doc_id, page_id } = this.props;
        navigate.to(`/app/e/${doc_id}/${page_id}`);
    };

    render() {
        if (this.state.processing) {
            return <Progress margin="50px 0" />;
        }

        const { selected } = this.props;
        const selectedOne = selected.length === 1;

        if (this.state.confirmDelete) {
            return (
                <Confirm
                    type={TYPE_FAILURE}
                    onConfirm={this.onConfirmDelete}
                    onCancel={this.onCancelDelete}
                    messageId={
                        selectedOne
                            ? "userDocForm.confirmRemove"
                            : "userDocForm.confirmRemoveAll"
                    }
                />
            );
        }

        return (
            <ButtonActionGroup>
                {this.state.showEdit && (
                    <Button
                        size={BTN_SMALL}
                        messageId="userDocForm.edit"
                        onClick={this.onEditClick}
                    />
                )}

                {this.state.showDelete && (
                    <Button
                        size={BTN_SMALL}
                        type={TYPE_FAILURE}
                        messageId="userDocForm.remove"
                        onClick={this.onDeleteClick}
                    />
                )}

                <Button
                    size={BTN_SMALL}
                    type={TYPE_SECONDARY}
                    messageId="form.return"
                    onClick={this.onReturnClick}
                />
            </ButtonActionGroup>
        );
    }
}

export default connect(null, mapDispatch)(Actions);
